/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Commission_Blocked_NegativeInputs */



/**
* | output |
* | --- |
* | "A customer's quarter nets negative, so the credit note needs handling by hand." |
*
* @param {Partner_Admin_Commission_Blocked_NegativeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_blocked_negative = /** @type {((inputs?: Partner_Admin_Commission_Blocked_NegativeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Blocked_NegativeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bei einem Kunden ist das Quartal negativ, daher muss die Gutschrift manuell bearbeitet werden.")
	return /** @type {LocalizedString} */ ("A customer's quarter nets negative, so the credit note needs handling by hand.")
});